import { InstanceInfo } from 'app/types-shared';

export const urlToAiChat = (
  linkUrl: string,
  instanceInfo?: InstanceInfo
): string => {

  if (!!linkUrl && !!instanceInfo?.envType && !!instanceInfo?.tenantId) {
    let cleanUrl = linkUrl.replace(/\/+$/, '');
    cleanUrl = cleanUrl.replace(/([^:]\/)\/+/g, '$1');
    return `${cleanUrl}/${instanceInfo?.envType}${instanceInfo?.tenantId}`;
  }

  return '';
};
